import { init } from '@ln/user.client.libs';
import sitiosId from '../Models/SitiosId';

function UserClientLibs() {
    const origenName = Object.keys(sitiosId).find(
        (key) => sitiosId[key] === sitiosId.ingresar
    );
    
    return init({
        keyDatadog: process.env.REACT_APP_DD_CLIENT_TOKEN,
        siteId: sitiosId.ingresar,
        environment: process.env.REACT_APP_ENV,
        serviceDatadog: origenName,
    });
}

const UCL = UserClientLibs();

export default UCL;
